var main_nav = (function( $ ) {

	var _init = function() {
		_setup_superfish();
	};

	var _setup_superfish = function() {
		$( '#main-nav' ).find( '.nav' ).superfish( {
			animation: {
				opacity: 'show',
				height: 'show',
			},
			speed: 'fast',
			delay: 0,
			autoArrows: false
		} );

		_open_menu_on_click();
	};

	/* Makes menu dropdowns open on click, instead of superfish default on hover */
	var _open_menu_on_click = function() {

		$('.sf-with-ul').on('mouseenter mouseout', function(e) {
			e.stopPropagation();
		})

		$('.sf-with-ul').on('click', function (e) {
			e.preventDefault();
			$(".dropdown-menu").toggle(!$(".dropdown-menu").is(':visible'));
		})
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = main_nav;